module.exports = __webpack_public_path__ + "media/vidcartoon-sushi.5a527b8b.mp4";